import {
  BarChart3,
  ChartPie,
  Copy,
  Download,
  Eye,
  FileBarChart,
  FileDown,
  List,
  Mail,
  MailPlus,
  Pencil,
  Send,
  Trash2,
  UserCog,
  Users,
} from 'lucide-react'

/**
 * The tone an action wears, read off its GLYPH.
 *
 * Row actions are drawn as soft chips in their tone (2026-10-19, the client's
 * request), so the colour is now seen on every row — and pages had drifted: the
 * same pencil was teal on one list, grey on another and blue on a third. The
 * common acts take one colour wherever they are drawn; any other glyph keeps the
 * tone its page gave it. A `danger` tone always stays red.
 */
const BY_GLYPH = new Map([
  // Edit and details — blue.
  [Pencil, 'info'],
  [List, 'info'],
  // A record's report — the pie chart (2026-10-22, the client's reference), in the
  // identity's teal: the row's main way in, and apart from the blue edit beside it.
  [ChartPie, 'brand'],
  // Look at it, the people behind it, a copy of it — violet.
  [Eye, 'violet'],
  [Users, 'violet'],
  [UserCog, 'violet'],
  [Copy, 'violet'],
  // Send, report, take away a file — green.
  [Mail, 'success'],
  [MailPlus, 'success'],
  [Send, 'success'],
  [FileBarChart, 'success'],
  [BarChart3, 'success'],
  [Download, 'success'],
  [FileDown, 'success'],
  // Delete — red.
  [Trash2, 'danger'],
])

/**
 * @param {import('react').ElementType} icon
 * @param {string} [tone]  the tone the page asked for
 */
export function actionTone(icon, tone) {
  if (tone === 'danger') return 'danger'
  return BY_GLYPH.get(icon) ?? tone
}
